import React from 'react'
import { isExternalLink } from './utils'
import { Link } from 'react-router-dom'

const shortenUrl = (url: string, keepChars: number) => {
    if (url.length <= keepChars * 2 + 3) return url
    return url.slice(0, keepChars) + '...' + url.slice(-keepChars)
}

const s3Url = (filename: string) => {
    // get first character of filename, lowercase
    const suffix = !filename.endsWith('.pdf') ? '.pdf' : ''
    const baseUrl = import.meta.env.VITE_S3_DOCS_BUCKET_URL || 'https://app-docs.financelab.se/'

    return `${baseUrl}${filename[0].toLowerCase()}/${filename}${suffix}`
}

export function SourceUrl({ url }: { url: string }) {
    if (!url) return null
    const linkUrl = isExternalLink(url) ? url : s3Url(url)
    return (
        <Link to={linkUrl} target='_blank'>
            {isExternalLink(url) ? shortenUrl(url, 20) : url}
        </Link>
    )
}
